<script lang="ts" setup>
import '../../../css/choice.css';
import { onMounted, onBeforeMount, reactive, ref } from 'vue';
import { ChoiceApi, LoadingSection } from '../../LibMain';
import { IInactiveProcedureLines } from '../../lib/Api/InactiveLines';
import ChoiceTable from "../../components/ChoiceTable.vue";
import { ICol, IRowSelection, RenderModeType } from '../../lib/ChoiceTableHelpers';
import { openWindowFromVue } from '../../lib/Models/CommonItemsModel';
import WindowHeaderFooter from '../../components/WindowHeaderFooter.vue';
import { claimEntryScreenUrl } from '../../lib/OfficeMdUrls';
import {AlignmentType, TableRowType} from
'../../Enums/UiEnums'
interface IBaseLines {
  data: IInactiveProcedureLines[] | undefined
}


const inactiveProcedureLines = reactive<IBaseLines>({
  data: undefined
});
const deposit_id = ref<number | null>();
const windowHeight = ref<number>();
const props = withDefaults(defineProps<{
  deposit_id: number
}>(), {});
onBeforeMount(async () => {
  deposit_id.value = props.deposit_id
  if (!deposit_id.value) {
    return;
  }
  inactiveProcedureLines.data = await ChoiceApi.inactiveLines.getInactiveLines(deposit_id.value);
})



async function refreshLines() {
  inactiveProcedureLines.data = undefined;
  if (!deposit_id.value) {
    return;
  }
  inactiveProcedureLines.data = await ChoiceApi.inactiveLines.getInactiveLines(deposit_id.value);
}
function onCellClick(colData :  ICol, row : IRowSelection,  _rowType: TableRowType, _evt: MouseEvent) : void {
        if (colData.ExtraData?.isClaim) {
            const data_row = <IInactiveProcedureLines> row;
            const claimURL = claimEntryScreenUrl(data_row.claim_id);
            openWindowFromVue("ClaimEntry", claimURL, { noTimestamp: "N" });
            return;
        }
      }
const tableColumns = ref<ICol[]>([
  { Name: 'Claim ID', DataField: 'claim_id', ExtraData: { isClaim: true }, RenderMode: RenderModeType.Clickable , HideFilter: true },
  { Name: 'Procedure Code', DataField: 'procedure_code', HideFilter: true },
  { Name:'Paid Totals', DataField:'paid_totals',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney, HideFilter: true },
  { Name:'Adjusted Totals', DataField:'adj_totals',Alignment: AlignmentType.Right,RenderMode: RenderModeType.AccountingMoney, HideFilter: true }
]);
</script>
<template>
  <WindowHeaderFooter :headerHeight="3.5" :footerHeight="4.5">
    <template v-slot:WindowHeader>
      <div class="isalus-page-title-large pt-2 pb-2">Inactive Procedure Lines</div>

    </template>
    <template v-slot:WindowBody>
      <div>
        <LoadingSection class="label-isalus-small" :isLoading="!inactiveProcedureLines.data"
          loadingMsg="Getting Inactive Procedure Lines">
          <ChoiceTable :data="inactiveProcedureLines.data" 
          :columns="tableColumns" 
          :height="windowHeight"
          :allowSorting="true" 
          :key-value-data-member="'claim_id'" 
          @cellclick="onCellClick"/>
        

        </LoadingSection>
      </div>
    </template>
    <template v-slot:WindowFooter>
      <div class="row mt-2 text-end ">
        <div class="col">
          <div class="btn-group" role="toolbar" aria-label="Cool ToolBar Collection">
            <button class="btn btn-primary btn-sm btn-key" @click="refreshLines()">
              Refresh Inactive Line List
            </button>
          </div>
        </div>
      </div>
    </template>
  </WindowHeaderFooter>
</template>